import { $api } from '@/services/backend/api';

export default function (store) {
    try {
        store.$api = $api;
    } catch (e) {
        console.error(e);
    }
}
